import Box from '@mui/material/Box';
import { RHFCheckboxField } from '@openx/components-core/lib/CheckboxField/RHFCheckboxField.tsx';
import { useMemo } from 'react';
import { type Path, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { exportType } from '../constants.ts';
import { AudienceFields, type AudienceForm } from '../types.ts';
import { getExportTargetLabels } from '../utils/getExportTargetLabels.ts';

export const TargetIdTypes = () => {
  const { t } = useTranslation();
  const { control } = useFormContext<AudienceForm>();

  const observableExportType = useWatch({ name: AudienceFields.ExportType, control });

  const targetIdLabels = useMemo(() => getExportTargetLabels(t), [t]);

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'row',
        gap: 1,
      }}
    >
      <RHFCheckboxField
        name={'export_targets.cookie' satisfies Path<AudienceForm>}
        label={targetIdLabels.cookie}
        margin="dense"
        data-test="target-id-cookie"
      />

      <RHFCheckboxField
        name={'export_targets.device' satisfies Path<AudienceForm>}
        label={targetIdLabels.device}
        margin="dense"
        data-test="target-id-device"
      />

      <RHFCheckboxField
        name={'export_targets.idl' satisfies Path<AudienceForm>}
        label={targetIdLabels.idl}
        margin="dense"
        data-test="target-id-idl"
      />

      <RHFCheckboxField
        name={'export_targets.ctv' satisfies Path<AudienceForm>}
        label={targetIdLabels.ctv}
        margin="dense"
        data-test="target-id-ctv"
      />

      {observableExportType !== exportType.BIDSTREAM_PLUS && (
        <>
          <RHFCheckboxField
            name={'export_targets.ip' satisfies Path<AudienceForm>}
            label={<Box sx={{ width: 'max-content' }}>{targetIdLabels.ip}</Box>}
            margin="dense"
            data-test="target-id-ip"
          />

          <RHFCheckboxField
            name={'export_targets.id5' satisfies Path<AudienceForm>}
            label={targetIdLabels.id5}
            margin="dense"
            data-test="target-id-id5"
          />
        </>
      )}
    </Box>
  );
};
